import React from 'react';
import styled from 'styled-components';

import Text from '../../Text';

const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.gray200};
  border-radius: 6px;
  padding: 22px 24px;
  margin-bottom: 12px;
`;

const Title = styled(Text).attrs({
  type: 'Body-2-w500',
  color: 'gray700',
})`
  margin-bottom: 12px;
`;

const Description = styled(Text).attrs({
  type: 'Body-2-w400',
  color: 'gray700',
})`
  p {
    ${({ theme }) => theme.textTypes['Body-2-w400']}
    margin: 0;
    a {
      color: ${({ theme }) => theme.colors.gray800};
    }
  }
`;

const DocumentCardLarge = ({ title, description }) => (
  <Card>
    <Title>{title}</Title>
    <Description>{description}</Description>
  </Card>
);

export default DocumentCardLarge;
